import React from 'react';
import axios from 'axios';

//ApiService
export default axios.create({
	 baseURL: 'http://localhost/2019/rest/api/',
	 headers: { 'X-Custom-Header': 'foobar' }
});
